/*
 * @Author: 张怀宇
 * @Date: 2020-05-29 15:39:03
 * @LastEditors: 张怀宇
 * @LastEditTime: 2020-07-03 13:23:05
 */ 
class UserInfo {
  biz_id ? : number;
  name ? : string;
  phone ? : string;
  image_url ? : string;
  role ? : string;
  user_id ? : number;
  profitsharing ? : boolean;
  comm_terminal ? : boolean;
  monitor?: boolean;
  special_user?: boolean;
  advert?:boolean;
  constructor(userInfo: UserInfo) {
    this.biz_id = userInfo.biz_id;
    this.name = userInfo.name;
    this.phone = userInfo.phone;
    this.image_url = userInfo.image_url;
    this.role = userInfo.role;
    this.user_id = userInfo.user_id;
    this.profitsharing = userInfo.profitsharing;  //是否有分账
    this.comm_terminal = userInfo.comm_terminal; //是否是原柜型
    this.monitor = userInfo.monitor;  //是否是监测柜
    this.special_user = userInfo.special_user;  //是否今麦郎用户
    this.advert = userInfo.advert; //是否有广告
  }
}

export default {
  state: {
    userInfo: new UserInfo({})
  },
  getters: {
    getUserInfo(state: any): UserInfo {
      return state.userInfo;
    }
  },
  mutations: {
    setUserInfo(state: any, userInfo: UserInfo) {
      state.userInfo = new UserInfo(userInfo);
    }
  }
};